import {
  GetDocumentIdSuccess,
  GetDocumentIdFailed,
} from './document-id.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { _Bottom } from '@angular/cdk/scrolling';
import { DocumentIdState } from './document-id.model';

export const initialState: DocumentIdState = {
  documentFields: [],
};

export function DocumentIdReducer(
  state: DocumentIdState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetDocumentIdSuccess,
    (state, { getDocumentIdResponse }) =>
      ({
        ...state,
        documentFields: getDocumentIdResponse,
      } as DocumentIdState)
  )
);
